import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import Logo from '../Logo/Logo';

const HeaderLogo = ({ href, isPublicSector, title }) => <div className="c-header-logo">
    <Button
      aria-label="Go to the Insight.com homepage"
      color="none"
      className="c-header-logo__btn"
      href={href}
    >
      <Logo isPublicSector={isPublicSector} title={title} />
    </Button>
  </div>

export default HeaderLogo;

HeaderLogo.propTypes = {
  href: PropTypes.string.isRequired,
  isPublicSector: PropTypes.bool,
  title: PropTypes.string,
};

HeaderLogo.defaultProps = {
  isPublicSector: false,
  title: '',
};
